import store from '../../../createStore';

const shouldValidateAddress = () => {
  const sourceConfig = store().getState().authReducer.appConfig;

  return sourceConfig.validate_avs && sourceConfig.validate_avs_street;
};

export default shouldValidateAddress;
